export var sliderElements = [{
  imageUrl: 'https://assets.chegg.com/image/upload/v1601928392/ux-assets/chegg-study/gbb-CBLH/img-cblh-chat-20200923.svg',
  alt: 'Instant help, 24/7',
  info: 'Chat up to 4 times a month with a real tutor to get unstuck',
  title: 'Instant help, 24/7',
  sessionValue: 'cblh',
  adobeValue: 'cblh'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/Math-illus.svg',
  alt: 'Math illustrations',
  info: 'Drill-down steps and graphing calculator—the minute you need it ',
  title: 'Chegg® Math Solver',
  sessionValue: 'math',
  adobeValue: 'math'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/Writing-illus.svg',
  alt: 'Writing',
  info: 'Fix plagiarism mistakes and have an expert review your paper',
  title: 'Chegg® Writing',
  sessionValue: 'writing',
  adobeValue: 'writing'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/Practice-illus.svg',
  alt: 'Practice',
  info: 'Prepare for tough exams with practice problems',
  title: 'Practice',
  sessionValue: 'practice',
  adobeValue: 'practice'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/Flashcards-illus.svg',
  alt: 'Flashcards',
  info: '500 million flashcards created by experts and other students',
  title: 'Chegg® Prep',
  sessionValue: 'prep',
  adobeValue: 'prep'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/VideoTBS-illus.svg',
  alt: 'Textbook Solutions',
  info: 'Textbook Solutions with',
  infoSec: 'step-by-step video explanations',
  title: 'Textbook Solutions',
  sessionValue: 'tbs',
  adobeValue: 'tbs'
}, {
  imageUrl: 'https://c.cheggcdn.com/assets/site/illustrations/QnA-illus.svg',
  alt: 'Ask a question',
  info: 'Ask a question and get an expert answer in as little as 30 mins',
  title: 'Expert Q&A',
  sessionValue: 'qna',
  adobeValue: 'expert q&a',
  isCSPLive: true
}];